/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Trigger_Desc7Inputs */

const en_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs on a schedule, on a webhook, or when something changes in your database, precisely when it should, every time.`)
};

const ar_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يعمل بجدول أو خطافات ويب أو عند تغيير شيء في قاعدة البيانات، في الوقت الصحيح تمامًا، كل مرة.`)
};

const bn_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শিডিউলে, ওয়েবহুকে বা ডেটাবেসে কিছু বদলালে চলে, যতক্ষণ দরকার, প্রতিবার সঠিক সময়ে।`)
};

const de_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft nach einem Zeitplan, auf einem Webhook oder wenn sich etwas in Ihrer Datenbank ändert, genau zum richtigen Zeitpunkt und jedes Mal.`)
};

const es_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ejecuta según una programación, en un webhook o cuando algo cambia en su base de datos, precisamente cuando debería, cada vez.`)
};

const fr_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'exécute selon un planning, sur un webhook ou lorsque quelque chose change dans votre base de données, précisément quand il le devrait, à chaque fois.`)
};

const pt_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É executado de acordo com um agendamento, em um webhook ou quando algo muda em seu banco de dados, exatamente quando deveria, sempre.`)
};

const zh_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按计划跑、由 webhook 触发，或数据库一变就跑，每次都在该跑的时候准时跑。`)
};

const tr_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa göre, bir webhook'ta ya da veritabanınızda bir şey değişince, her seferinde tam zamanında çalışır.`)
};

const ru_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запускается по расписанию, на вебхук или когда что-то меняется в вашей базе, каждый раз ровно вовремя.`)
};

const pl_svc_automation_trigger_desc7 = /** @type {(inputs: Svc_Automation_Trigger_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działa zgodnie z harmonogramem, na webhooku lub gdy coś zmieni się w bazie danych, dokładnie wtedy, gdy powinno, za każdym razem.`)
};

/**
* | output |
* | --- |
* | "Runs on a schedule, on a webhook, or when something changes in your database, precisely when it should, every time." |
*
* @param {Svc_Automation_Trigger_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_trigger_desc7 = /** @type {((inputs?: Svc_Automation_Trigger_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Trigger_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_trigger_desc7(inputs)
	if (locale === "bn") return bn_svc_automation_trigger_desc7(inputs)
	if (locale === "de") return de_svc_automation_trigger_desc7(inputs)
	if (locale === "es") return es_svc_automation_trigger_desc7(inputs)
	if (locale === "fr") return fr_svc_automation_trigger_desc7(inputs)
	if (locale === "pt") return pt_svc_automation_trigger_desc7(inputs)
	if (locale === "zh") return zh_svc_automation_trigger_desc7(inputs)
	if (locale === "tr") return tr_svc_automation_trigger_desc7(inputs)
	if (locale === "ru") return ru_svc_automation_trigger_desc7(inputs)
	if (locale === "pl") return pl_svc_automation_trigger_desc7(inputs)
	return en_svc_automation_trigger_desc7(inputs)
});
export { svc_automation_trigger_desc7 as "svc_automation_TRIGGER_desc" }